<template>
  <div class="box">
    <Header title="价格查询"></Header>
    <div class="show-box">
      <div class="title-card" style="z-index: unset;">
        <div class="inquriy-box">
          <div class="inquriy-left">
            <img class="left-img" src="../assets/images/priceInquriy2.png" alt />
          </div>
            <div class="inquriy-search">
              <van-search
                type="text"
                class="top-search"
                v-model="dealerName"
                shape="round"
                left-icon
                placeholder="请输入经销商名称"
                background="none"
                show-action
                action-text="清空"
                :clearable = "false"
                @focus="dealerListShow = true"
                @blur="dealerTimeout"
                @input="onInput"
                @cancel="clearSearchBox">
              </van-search>
              <!-- <div class="dealer-list-box"> -->
              <!-- <van-popup class="dealer-pop" v-model="dealerListShow" :overlay="false">
                <div class="dealer-list-item"
                  v-for="(item, index) in dealerNameOpt"
                  :key="index"
                  :value="item.gomsName"
                  @click="dealerChoose(item.gomsName)">
                  {{item.gomsName}}
                </div>
              </van-popup> -->
              <div class="dealer-list-box" v-if="dealerListShow" >
                <div class="dealer-list-item"
                  v-for="(item, index) in dealerNameOpt"
                  :key="index"
                  :value="item.gomsName"
                  @click="dealerChoose(item.gomsName)">
                  {{item.gomsName}}
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="inquriy-list-box">
        <div style="display: flex">
          <div class="inquriy-center">
            <van-search
              class="top-search"
              v-model="searchValue"
              shape="round"
              clearable
              left-icon
              placeholder="请输入零件关键字"
              background="none"
              @search="searchHandle"
              />
            </div>
            <div class="inquriy-right">
              <img
                class="right-img"
                src="../assets/images/search.png"
                alt
                @click="searchHandle"
              />
            </div>
        </div>
        <div class="notify-box" v-if="!inquriyShowFlag">
          <img class="notify-img" src="../assets/images/priceInquriy2.png" alt />
        </div>
        <div class="list-box" v-if="inquriyShowFlag">
          <div class="noDataMsg" v-if="noData">没有找到相关零件信息</div>
          <div class="list-title" v-if="!noData">
            <div class="list-title-partNo">零件号</div>
            <div class="list-title-desc">零件名称</div>
            <div class="list-title-descCn">中文名称</div>
          </div>
          <van-list
            class="list-ul"
            finished-text="没有更多了"
            :finished="finished"
            v-model="loading"
            v-if="!noData"
            offset="10"
            @load="searchInquriy()"
          >
            <li
              class="list-li"
              v-for="(item, index) in inquriyList"
              :key="index"
              @click="clickToPageDetail(item.id)"
            >
              <div class="list-partNo" v-text="item.id"></div>
              <div class="list-desc" v-text="item.name"></div>
              <div class="list-descCn" v-text="item.catalogDesc"></div>
            </li>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInquriy, getDealerName } from "@/api/priceSearch";
// import { getInquriy } from "@/api/priceSearch";
import { STATUS_CODE_OK } from "@/config";
import store from "@/store";
import { mapActions } from "vuex";
import Header from "@/components/Header";
import { Toast } from 'vant';

export default {
  name: "priceSearch",
  data() {
    return {
      userCode: "",
      iconId: "",
      dealerId: "",
      memberId: "",
      dealerName: "",
      // dealerNameList: ["Internet Explorer","Firefox","Chrome","Opera","Safari"],
      dealerNameList: [],
      dealerNameOpt: [],
      searchValue: "",
      pageNo: 0,
      displayCount: 8,
      inquriyShowFlag: false,
      loading: false,
      finished: false,
      refreshing: false,
      inquriyList: [],
      noData: false,
      dealerListShow: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm=>{
      if (from.fullPath && from.fullPath == '/priceSearchDetail') {
        if (store.getters.searchContent) {
          vm.searchValue = store.getters.searchContent;
          vm.searchHandle()
        }
      } else {
        vm.setSearchContent("");
      }
    })
  },
  created () {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.userCode = store.getters.userCode;
      this.iconId = localStorage.getItem('iconId');
      this.dealerName = localStorage.getItem('dealerName');
      localStorage.removeItem('dealerId');
      localStorage.removeItem('dealerName');
      localStorage.removeItem('memberId');
      getDealerName({
        userCode: this.userCode, //客户号
        iconId: this.iconId //图标ID
      }).then((res) => {
        this.dealerNameList = res.data.userNameListVo;
        this.remoteMethod();
        this.dealerListShow = false;
      })
    },
    // 查询数据
    async searchHandle() {
      this.setSearchContent(this.searchValue);
      this.finished = false;
      this.inquriyList = [];
      this.pageNo = 1;
      let { data } = await getInquriy({
        pageNo: this.pageNo,
        displayCount: this.displayCount,
        name: this.searchValue,
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        if (data.goodsBeans && data.goodsBeans.length < 1) {
          this.noData = true;
          this.finished = true;
        } else {
          for (var i = 0; i < data.goodsBeans.length; i++) {
            this.inquriyList.push(data.goodsBeans[i]);
          }
          this.noData = false;
          if (data.goodsBeans.length < this.displayCount) {
            this.finished = true;
          }
        }
        this.inquriyShowFlag = true;
      }
    },
    //滑动刷新
    async searchInquriy() {
      this.pageNo = this.pageNo + 1;
      let { data } = await getInquriy({
        pageNo: this.pageNo,
        displayCount: this.displayCount,
        name: this.searchValue,
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        if (data.goodsBeans && data.goodsBeans.length < 1) {
          this.finished = true;
          this.loading = false;
        } else {
          for (var i = 0; i < data.goodsBeans.length; i++) {
            this.inquriyList.push(data.goodsBeans[i]);
          }
        }
        if (data.goodsBeans.length < this.displayCount) {
          this.finished = true;
        }
      } else {
        this.finished = true;
      }
      this.loading = false;
    },
    dealerNameCheck() {
      for (var i = 0;i < this.dealerNameList.length; i++){
        if (this.dealerName == this.dealerNameList[i].gomsName){
          this.dealerId = this.dealerNameList[i].gomsId
          this.memberId = this.dealerNameList[i].memberId
          return true;
        }
      }
      return false;
    },
    onInput() {
      this.remoteMethod();
      if (this.dealerNameOpt.length == 0){
          this.dealerListShow = false;
        } else {
          this.dealerListShow = true;
        }
    },
    remoteMethod() {
      if (this.dealerName && this.dealerName !== '') {
        this.dealerNameOpt = [];
        let count = 0;
        for (var i = 0;i < this.dealerNameList.length;i++){
          if (this.dealerNameList[i].gomsName.includes(this.dealerName)) {
            count ++;
            if (count > 50) {
              break;
            }
            this.dealerNameOpt.push(this.dealerNameList[i])
          }
        }
        if (this.dealerNameOpt.length == 0){
          this.dealerListShow = false;
        } else {
          this.dealerListShow = true;
        }
      } else {
        this.dealerNameOpt = JSON.parse(JSON.stringify(this.dealerNameList));
      }
    },
    dealerChoose(name) {
      this.dealerName = name;
      this.remoteMethod();
      this.dealerListShow = false;
    },
    clearSearchBox() {
      this.dealerName = "";    
      // this.remoteMethod();
      this.dealerListShow = false;
    },
    dealerTimeout() {
      setTimeout(()=>{ 
        this.dealerListShow = false;
      },300);
    },
    clickToPageDetail(id) {
      if (this.dealerName == null || this.dealerName == "") {
        Toast({
          className: '请填写经销商名称',
          message: '请填写经销商名称',
          position: 'top',
          duration: 3 * 1000
        })
        return;
      }
      if (!this.dealerNameCheck()){
        Toast({
          className: '请填写正确的经销商名称',
          message: '请填写正确的经销商名称',
          position: 'top',
          duration: 3 * 1000
        })
        return;
      }
      localStorage.setItem('dealerId', this.dealerId);
      localStorage.setItem('dealerName', this.dealerName);
      localStorage.setItem('memberId', this.memberId);
      this.setPartNo(id);
      this.$router.push({
        name: "priceSearchDetail",
      });
    },
    ...mapActions(["setPartNo", "setSearchContent"]),
  },
  components: {
    Header,
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  .inquriy-box {
    display: flex;
    align-items: center;
    width: 100%;
    .inquriy-left {
      padding: 0px 0px 10px 20px;
      .left-img {
        width: 50px;
        height: 50px;
      }
    }
    .inquriy-search {
      width: 80%;
      margin-left: 10px;
      padding: 0px 10px 0px 0px;
      width: -webkit-fill-available;
      position: relative;
      .top-search {
        padding: 0px;
        .van-cell {
          padding: 0px 10px 0px 0px;
        }
        /deep/ .van-field__control {
          padding: 0px 15px;
        }
        /deep/ .van-search__action {
          color: #fff;
          background-color: #da291c;
        }
      }
    }
    .dealer-list-box {
      position: absolute;
      max-height: 350px;
      min-height: 100px;
      background-color:white;
      z-index: 999;
      top: 30px;
      left: 0px;
      right: 14px;
      overflow-y: auto;
      overflow-x: hidden;
      box-shadow: 0px 0px 5px 0px #b9b9b9;
      border-radius: 5px;
    }
      /deep/ .van-popup {
        position: absolute;
        max-height: 300px;
      }
      /deep/ .van-popup--center {
        top: 29px;
        left: 5px;
        right: 20px;
        -webkit-transform: unset;
        transform: unset;
      }
    .dealer-list-item{
      font-size: 14px;
      line-height: 16px;
      padding: 8px 10px;
      text-align: left;
    }
    .inquriy-right{
      padding: 6px 20px 0px 0px;
      .right-img {
        margin-top: 10px;
        width: 50px;
        height: 50px;
      }
    }
  }
  .inquriy-center {
    margin-left: 10px;
    padding: 0px 10px 0px 0px;
    width: 80%;
    .top-search {
      padding: 0px;
      .van-cell {
        padding: 0px 10px 0px 0px;
      }
      /deep/ .van-field__control {
        padding: 0px 15px;
      }
    }
  }
  .inquriy-right{
    margin-top: -14px;
    .right-img {
      width: 50px;
      height: 50px;
    }
  }
  .inquriy-list-box {
    position: absolute;
    top: 120px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    padding: 0px 10px;
    .notify-box {
      // display: flex;
      margin-top: 30px;
      position: relative;
      height: 80%;
      justify-content: center;
      align-items: center;
      .notify-img {
        margin-top: 60px;
        max-width: 200px;
      }
    }
    .list-box {
      .list-title {
        display: flex;
        height: 35px;
        // background: linear-gradient(to right, #da291c 60%, #f2404d);
        background: #da291c;
        border-radius: 20px 20px 0px 0px;
        padding: 0px 10px 0px 30px;
        align-items: center;
        text-align: left;
        font-size: 12px;
        color: white;
        .list-title-partNo {
          width: 29%;
        }
        .list-title-desc {
          width: 38%;
        }
        .list-title-descCn {
          width: 32%;
        }
      }
      .list-ul {
        border-radius: 0px 0px 20px 20px;
        font-size: 10px;
        margin-bottom: 20px;
        .list-li {
          display: flex;
          height: 50px;
          border-bottom: 1px solid #dcdcdc;
          align-items: center;
          text-align: left;
          padding: 0px 10px 0px 20px;
          margin: 0px 10px;
        }
        .list-partNo {
          width: 30%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-right: 15px;
          word-break: break-all;
        }
        .list-desc {
          padding-right: 15px;
          width: 40%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
        }
        .list-descCn {
          width: 30%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
        }
      }
    }
  }
}
</style>